import ApiConnection from "./connection";

const login = async (userData) =>
  ApiConnection.post(`users/auth`, userData)
    .then((response) => {
      return {
        output: response.data,
        status: response.status,
        message: "erro",
      };
    })
    .catch((e) => {
      return { status: e.response.status, message: e.response.data.message };
    });

const getAllByPage = async (token) =>
  ApiConnection.get(`users`, { headers: { Authorization: `Bearer ${token}` } })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response.status };
    });

const getByID = async (token, id) =>
  ApiConnection.get(`users/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response.status };
    });

const create = async (token, userData) =>
  ApiConnection.post(`users`, userData, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response.status };
    });

const update = async (token, userData, userID) =>
  ApiConnection.put(`users/${userID}`, userData, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response.status };
    });

const ban = async (token, userID) =>
  ApiConnection.put(
    `users/${userID}/ban`,
    {},
    { headers: { Authorization: `Bearer ${token}` } },
  )
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response.status };
    });

const active = async (token, userID) =>
  ApiConnection.put(
    `users/${userID}/active`,
    {},
    { headers: { Authorization: `Bearer ${token}` } },
  )
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response.status };
    });

const insertDesfecho = async (token, Data) => {
  return ApiConnection.post(`desfecho/insert`, Data, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response?.status };
    });
};

const updateDesfecho = async (token, Data) => {
  return ApiConnection.post(`desfecho/update`, Data, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response?.status };
    });
};

const deleteDesfecho = async (token, Data) => {
  return ApiConnection.post(`desfecho/delete`, Data, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response?.status };
    });
};

const getAllArquives = async (token) => {
  try {
    const response = await ApiConnection.get("files", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return { output: response.data, status: response.status };
  } catch (e) {
    return { status: e.response.status };
  }
};

const getAllUnimedMama = async (token) => {
  try {
    const response = await ApiConnection.get("unimed-mama", {
      headers: { Authorization: `Bearer ${token}` },
    });

    return { output: response.data, status: response.status };
  } catch (e) {
    return {
      status: e.response?.status || 500,
      output: null,
    };
  }
};

const getAllRedeSus = async (token, username) => {
  try {
    const response = await ApiConnection.get(
      `rede-sus/getAll/${username}`, //
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return { output: response.data, status: response.status };
  } catch (e) {
    return {
      status: e.response?.status || 500,
      output: null,
    };
  }
};

const getHistoricTumorBoard = async (token, data) => {
  try {
    const response = await ApiConnection.post(`tumor-board/getHistoric`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return { output: response.data, status: response.status };
  } catch (e) {
    return {
      status: e.response?.status || 500,
      output: null,
    };
  }
};

const HideReport = async (token, Data) => {
  return ApiConnection.post(`tumor-board/hide-report`, Data, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response?.status };
    });
};

const insertHistoric = async (token, Data) => {
  return ApiConnection.post(`tumor-board/insert-historic`, Data, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response?.status };
    });
};

const registerTumorBoard = async (token, Data) => {
  return ApiConnection.post(`tumor-board/register`, Data, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response?.status };
    });
};

const updateTumorBoard = async (token, Data) => {
  return ApiConnection.post(`tumor-board/update`, Data, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response?.status };
    });
};

const getAllTumorBoard = async (token, username) => {
  try {
    const response = await ApiConnection.get(`tumor-board/getAll/${username}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return { output: response.data, status: response.status };
  } catch (e) {
    return {
      status: e.response?.status || 500,
      output: null,
    };
  }
};

const getAllTumorBoardPatients = async (token, username, NomPaciente) => {
  try {
    const response = await ApiConnection.get(
      `tumor-board/getAllPac/${username}/${NomPaciente}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return { output: response.data, status: response.status };
  } catch (e) {
    return {
      status: e.response?.status || 500,
      output: null,
    };
  }
};

const getDesfecho = async (token) => {
  try {
    const response = await ApiConnection.get("unimed-desfecho", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return { output: response.data, status: response.status };
  } catch (e) {
    return { status: e.response.status };
  }
};

const GetTumorBoardReports = async (token, CodPaciente, username) => {
  try {
    const response = await ApiConnection.get(
      `tumor-board/getReports/${username}/${CodPaciente}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return { output: response.data, status: response.status };
  } catch (e) {
    return { status: e.response.status };
  }
};

const getAllUnimedMamaByDate = async (token, username, dateStart, dateEnd) => {
  try {
    const response = await ApiConnection.get(
      `/unimed-mama-by-date/${dateStart}/${dateEnd}/${username}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return { output: response.data, status: response.status };
  } catch (e) {
    return { status: e.response?.status };
  }
};

const getAllRedeSusByDate = async (token, username, dateStart, dateEnd) => {
  try {
    const response = await ApiConnection.get(
      `/rede-sus-by-date/${dateStart}/${dateEnd}/${username}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return { output: response.data, status: response.status };
  } catch (e) {
    return { status: e.response?.status };
  }
};

export default function user() {
  return {
    getAllArquives,
    insertDesfecho,
    updateDesfecho,
    getAllRedeSusByDate,
    deleteDesfecho,
    getAllRedeSus,
    getAllTumorBoard,
    getAllUnimedMama,
    getAllUnimedMamaByDate,
    getDesfecho,
    HideReport,
    GetTumorBoardReports,
    login,
    getByID,
    getAllByPage,
    create,
    registerTumorBoard,
    ban,
    updateTumorBoard,
    active,
    insertHistoric,
    getHistoricTumorBoard,
    update,
    getAllTumorBoardPatients,
  };
}
